import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { Col, Row, Input } from "reactstrap";
import TaxRatesTableDropdown from "./taxRatesTableDropdown";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

const TaxRatesTable = ({
  tableData,
  defaultSorted,
  searchQuery,
  onEdit,
  disabled,
}) => {

  const CATEGORY_LABELS = {
    vat_gst: "VAT / GST",
    wht: "WHT",
    other: "Other",
  };

  const CALCULATION_METHOD_LABELS = {
    inclusive: "Inclusive",
    exclusive: "Exclusive",
  };

  const categoryFormatter = (cell) => (
    <span>{CATEGORY_LABELS?.[cell] || cell || "-"}</span>
  );

  const calculationMethodCalculator = (cell) => (
    <span>
      {CALCULATION_METHOD_LABELS?.[cell] || cell || "-"}
    </span>
  );

  const actionFormatter = (cell, row) => {
    return (
      <TaxRatesTableDropdown
        data={row}
        onEdit={onEdit}
        disabled={disabled}
      />
    );
  };

  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true,
      formatter: (cell) => <span className="fontWeight700">{cell}</span>,
      headerStyle: (colum, colIndex) => {
        return { width: "150px" };
      }
    },
    {
      dataField: 'rate',
      text: 'Rate (%)',
      sort: true,
      formatter: (cell) => <span>{cell} %</span>,
      headerStyle: (colum, colIndex) => {
        return { width: "120px" };
      }
    },
    {
      dataField: 'category',
      text: 'Category',
      sort: false,
      formatter: categoryFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "120px" };
      }
    },
    {
      dataField: 'calculation_method',
      text: 'Calculation Method',
      sort: false,
      formatter: calculationMethodCalculator,
      headerStyle: (colum, colIndex) => {
        return { width: "120px" };
      }
    },
    {
      dataField: 'legal_text',
      text: 'Legal Note Text',
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "120px" };
      }
    },
    {
      dataField: 'action',
      text: 'Action',
      formatter: actionFormatter,
      sort: false,
      headerStyle: (colum, colIndex) => {
          return { width: "70px" };
      }
    },
  ];


  const handleTableChange = (type, { sortField, sortOrder, data }) => {
    const ascDesc = sortOrder === "desc" ? "-" : "";
    if (sortField === "name" && typeof searchQuery?.setOrdering === "function") {
      searchQuery.setOrdering({
        order: ascDesc,
        name: sortField,
        sort: sortField,
      });
    }
  }

  return (
    <>
      <ToolkitProvider
        keyField="id"
        data={tableData}
        columns={columns}
        search={{
          searchFormatted: true
        }}
        exportCSV={ {
          fileName: 'tax-rates.csv',
        }}
      >
        {props => (
          <div>
            <Row>
              <Col>
                <div className="customSearch">
                  <Input
                    placeholder="Search..."
                    value={searchQuery?.query ?? props?.searchProps?.searchText ?? ""}
                    style={{ marginBottom: 10 }}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (typeof searchQuery?.setQuery === "function") {
                        searchQuery.setQuery(value);
                        return;
                      }
                      if (typeof props?.searchProps?.onSearch === "function") {
                        props.searchProps.onSearch(value);
                      }
                    }}
                  />
                </div>
              </Col>
            </Row>

            <BootstrapTable
              {...props.baseProps}
              bordered={ false }
              defaultSorted={defaultSorted}
              remote={ { sort: true } }
              onTableChange={handleTableChange}
            />
          </div>
        )}
      </ToolkitProvider>
    </>
  );
};

export default TaxRatesTable;
